export const NAV_STATE_KEY = "NAVIGATION_STATE";

export const getNavList = (state) => {
    return state[NAV_STATE_KEY].navList;
};
